export default class ObjectHelper {
    static isNullOrEmpty(obj) {
        return typeof obj === 'undefined' || obj === null || obj.length === 0;
    }

    static isDefined(obj) {
        return typeof obj !== 'undefined' && obj !== null;
    }

    static isArray(obj){
        if (typeof Array.isArray === 'undefined') {
          return Object.prototype.toString.call(obj) === '[object Array]';
        }

        return Array.isArray(obj);
    }

    static isString(obj) {
        return typeof obj === 'string';
    }

    static isNumber(obj) {
        return typeof obj === 'number';
    }

    static isDate(obj) {
        return obj instanceof Date;
    }
}